import { validChannelInPath } from "@presentation/shared/utils/url";
import { useState, useEffect, PropsWithChildren } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { hasRecaptchaDisabled } from "@presentation/shared/utils/recaptcha";

export const DynamicRecaptchaProvider = ({ children }: PropsWithChildren) => {
  const [siteKey, setSiteKey] = useState("");

  useEffect(() => {
    if (hasRecaptchaDisabled()) return;
    if (validChannelInPath('digital')) {
      setSiteKey(process.env.GATSBY_API_RECAPTCHA_DIRECT?.toString() ?? '');
    } else {
      setSiteKey(process.env.GATSBY_API_RECAPTCHA?.toString() ?? '');
    }
  }, []);

  if (hasRecaptchaDisabled()) return children;
  if (!siteKey) return null;

  return (
    <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
      {children}
    </GoogleReCaptchaProvider>
  );
};